export default {
  name: 'wisk-clone',
  width: 35,
  height: 35,
  paths: [
    { d: 'M35,4.1v20.8c0,2.3-1.9,4.2-4.2,4.2c0,0,0,0,0,0h-1.7V11.1c0-2.9-2.3-5.2-5.2-5.2H5.8V4.1C5.9,1.8,7.7,0,10,0h20.8 C33.1,0,35,1.8,35,4.1z' },
    { d: 'M27,11.1v20.8c0,1.7-1.4,3.1-3.1,3.1H3.1C1.4,35,0,33.6,0,31.9V11.1C0,9.4,1.4,8,3.1,8c0,0,0,0,0,0h20.8 C25.6,8,27,9.4,27,11.1C27,11.1,27,11.1,27,11.1z' }
  ]
}
